<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div class="col-12 nopads">
        <team-item
            v-for="team in teams"
            :key="team.id"
            :team="team.team"
            @edit="showTeamInfo"/>
    </div>
</template>

<script>
    import TeamItem from "../team/TeamItem";

    export default {
        name: "found-team-list",
        components: {TeamItem},
        props: {
            teams: {
                type: Array,
                default() {
                    return null
                }
            }
        },

        data() {
            return {
            }
        },

        methods: {
            showTeamInfo: function (team) {
                this.$router.push({name: 'team-info-view', params: {teamInfo: team, id: team.id}})
            }
        }
    }
</script>

<style scoped>

</style>
